import { SagaIterator } from '@redux-saga/core'
import { all, takeLatest, put, call } from 'redux-saga/effects'
import { Action } from 'lib/redux/models'
import { CONTENT } from '../actionTypes'
import getProtagonistaLayout from 'services/protagonistas/getProtagonistaLayout'

function* getLayoutContent(action: Action) {
  try {
    const data = yield call(getProtagonistaLayout, action?.payload)
    if (data) {
      yield put(CONTENT.success(data))
    }
  } catch (error) {
    yield put(CONTENT.failure(error.message))
  } finally {
    yield put(CONTENT.fulfill())
  }
}

export function* protagonistaLayoutSagas(): SagaIterator {
  yield all([takeLatest(CONTENT.TRIGGER, getLayoutContent)])
}
